export default __webpack_public_path__ + "static/media/logo-web-liberty16.69c91f06.png";